import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'

export default {
  mixins: [mixx],
  name: 'ventaDia',
  data() {
    return {
      msg: '-',
      loading: false,
      loading_f: false,
      tbv: null,
      f_c: {
        desde: this.date_rest(this.currentdate(), -6),
        hasta: this.currentdate(),
      },
      medios: [],
      data: []
    }
  },
  mounted() { 
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px"); 
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      'rowCallback': function (row, data, index) { },

    });
    $('.box').boxWidget();
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  
  methods: {
    descargar() {
      this.to_excel_name2($("#dett").html(), 'dett', 'Plus Pagos - Cupones por día');
    },
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/billeteras/PP/cupones/dia', this.f_c)
        .then(response => {
          if (response.data.status == 1) {
            this.data = response.data.data;
            this.medios = response.data.medios;
          } else {
            this.data = [];
            this.medios = [];
          }
          this.loading = false;
        });


    },

  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/ppCuponesDia/index.js